import { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles.css';

import { API_URL } from '../config';

function Unsubscribe() {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleUnsubscribe = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get('email');
        
        if (!email) {
          setStatus('error');
          setMessage('No email address provided in the unsubscribe link.');
          return;
        }

        const response = await axios.get(`${API_URL}/api/unsubscribe?email=${encodeURIComponent(email)}`);
        setStatus('success');
        setMessage(response.data.message);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.error || 'An error occurred while processing your unsubscribe request.');
      }
    };

    handleUnsubscribe();
  }, []);

  return (
    <div className="container" style={{ textAlign: 'center', padding: '40px 20px' }}>
      <h1>Unsubscribe from True Devotion</h1>
      
      {status === 'loading' && (
        <div>
          <p>Processing your unsubscribe request...</p>
        </div>
      )}
      
      {status === 'success' && (
        <div style={{ color: '#28a745' }}>
          <h2>✅ Successfully Unsubscribed</h2>
          <p>{message}</p>
          <p>You will no longer receive daily question emails.</p>
          <p>You can always re-enable daily questions by logging into your account and updating your email preferences.</p>
          <button 
            onClick={() => window.location.href = '/login'}
            className="btn-centered"
            style={{ marginTop: '20px' }}
          >
            Go to Login
          </button>
        </div>
      )}
      
      {status === 'error' && (
        <div style={{ color: '#dc3545' }}>
          <h2>❌ Error</h2>
          <p>{message}</p>
          <p>If you continue to have issues, please contact support.</p>
          <button 
            onClick={() => window.location.href = '/login'}
            className="btn-centered"
            style={{ marginTop: '20px' }}
          >
            Go to Login
          </button>
        </div>
      )}
    </div>
  );
}

export default Unsubscribe;
